import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { ReactComponent as Filter } from '../../assets/SVG/filter.svg';
import { useTranslation } from 'react-i18next';

interface SearchFilterProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  onFilterClick?: () => void;
  billType?: string;
  showSearchbar?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SearchFilter: React.FC<SearchFilterProps> = ({ searchTerm, setSearchTerm, onFilterClick, billType, showSearchbar = true }) => {
  const { t } = useTranslation('Packagebilling');

  
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', py: 1 }}>
      <IconButton onClick={onFilterClick}>
        <Filter style={{ width: '40px', height: '40px', cursor: 'pointer' }} />
      </IconButton>
      {showSearchbar && (
        <TextField
        
          variant="outlined"
          placeholder={t('search_by_patient_name')}
          label={t('search')}
          size="small"
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          sx={{ width: 320 }}
        />
      )}
    </Box>
  );
};

export default SearchFilter;
